<template>
  <a-select :disabled="disabled" :allowClear="allowClear" @change="changeValue" v-model="input" v-bind="$attrs"
            v-on="$listeners" :placeholder="placeholder?placeholder:$t('baseVO.selectPlaceholder')">
    <a-icon slot="suffixIcon" type="caret-down"/>
    <a-select-option v-for="(item,index) in companyInfos"
                     :disabled="disabledIds.length > 0 && disabledIds.indexOf(item.id) > -1" :key="index"
                     :value="item.id">{{item.name}}
    </a-select-option>
  </a-select>
</template>

<script>
  import UserApi from '@/api/sys/user'
  import { mapState } from 'vuex'
  import store from '@/store'

  export default {
    name: 'ptStatisticsCompanySelect',
    props: {
      tableName:{
        type: String,
        default:'T_WS_EMPLOYEE_STATISTICS',
      },
      disabled: {
        type: Boolean,
        default: false
      },
      placeholder: {
        type: String
      },
      allowClear: {
        type: Boolean,
        default: true
      },
      value: {
        type: [Object, Array] | String
      },
      disabledIds: {
        type: Array,
        default: () => {
          return []
        }
      },
      //是否设置默认值第一个
      isFirst: {
        type: Boolean,
        default: false
      },
      selectNow: {
        type: Boolean,
        default: false
      },
      showAll: {
        type: Boolean,
        default: false
      },
      initAll:{
        type: Boolean,
        default: false
      },
    },
    computed: {
      ...mapState({
        userInfo: state => state.user.info
      })
    },
    data() {
      return {
        input: this.value,
        companyInfos: []
      }
    },
    watch: {
      value(val) {
        this.input = val
      },
      input(val) {
        this.$emit('input', val)
      }
    },
    mounted() {
      this.initData()
    },
    methods: {
      initData() {
        UserApi.getStatisticsCompanyInfo(this.tableName).then(res => {
          if (res.code == 1) {
            this.companyInfos = res.data.map(o=>{
              if(o.id == 'a5ccfb0d7b540c6e'){
                o.id = -1;
              }
              return o;
            })
            if(this.initAll && this.companyInfos.map(item => item.id).includes(-1)){
              this.input = -1
              this.$emit('input', -1)
              this.$emit('change', this.input)
            }
            if(this.showAll && !this.companyInfos.map(item => item.id).includes(-1)){
              this.companyInfos.unshift({id:-1,name:'全部'})
            }
            if (this.isFirst && !this.value) {
              if(this.showAll){
                this.input = -1
              }else{
                this.input = this.userInfo.employeeDO.companyId
              }
              this.$emit('input', this.input)
              this.$emit('change', this.input)
            }
          }
        }).finally(()=>{
          this.$emit('ready', this.input)
        })

      },
      changeValue(value) {
        this.$emit('input', value)
      }
    }
  }
</script>

<style scoped lang="less">

</style>